/* eslint-disable react/no-danger */
import NonProfitIndustryPage from "@components/NonProfitIndustryPage";
import validatePaidCampaign from "@helpers/validatePaidCampaign";
import axios from "axios";
import dynamic from "next/dynamic";
import React, { Component } from "react";
import { animateScroll as scroll } from "react-scroll";
import FooterComponent from "@/components/Footer/FooterComponent";
import Header from "@/components/Header/Header";
import SEOHead from "@/components/SEOHead/SEOHead";
import { WordPressAPI } from "../../../config";
import sanitizeHtml from 'sanitize-html';

const FooterNewsModal = dynamic(import("@/components/FooterNewsModal"));

const scriptData = JSON.stringify({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [{
    "@type": "Question",
    "name": "How do I prepare a balance sheet for a non-profit organization?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "The general equation used to calculate a non-profit balance sheet, called a Statement of Financial Position, is \"liabilities + net assets = assets.\" While it may seem simple, it's recommended that you work with a tax professional familiar with navigating financial reporting in the non-profit space."
    }
  }, {
    "@type": "Question",
    "name": "Do non-profits get a 1099?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "If your non-profit used contract workers or vendors to work for your organization during the year, you must submit a Form 1099 to the IRS. If you have not utilized these services during the year, you do not need to submit a Form 1099."
    }
  }]
})

class NonProfitIndustry extends Component {
  state = {
    isSchedulerOpen: false,
    PaidCampaign: 1,
    hideSchedulerHeader: false,
  };

  componentDidUpdate() {
    if (this.state.isSchedulerOpen) {
      document.body.classList.add("no-overflow");
    } else {
      document.body.classList.remove("no-overflow");
    }
  }

  scrollUp = () => {
    scroll.scrollToTop({
      duration: 250,
    });
  };

  toggleIsSchedulerOpen = () => {
    this.setState((prevState) => ({
      isSchedulerOpen: !prevState.isSchedulerOpen,
      hideSchedulerHeader: !prevState.isSchedulerOpen,
    }));
  };



  render() {
    const { data } = this.props;
    const { title, acf } = this.props.data;
    const paid_campaign = validatePaidCampaign(acf.paid_campaign);
    const { additional_questions } = acf;

    return (
      <div>
        <Header
          AdditionalQuestions={additional_questions}
          PaidCampaign={
            typeof paid_campaign === "undefined" ? 1 : paid_campaign
          }
          phone_number={acf.phone_number_setup}
          leadValues={acf.lead_values}
          hideSchedulerHeader={this.state.hideSchedulerHeader}
        />
        <SEOHead>
          <title>{acf?.page_title_tag}</title>
          <meta
            name="description"
            content={acf?.meta_description || ""}
            key="description"
          />
          <script
            type="text/javascript"
            src="//app-ab33.marketo.com/js/forms2/js/forms2.min.js"
          />
          <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: sanitizeHtml(scriptData) }} />
        </SEOHead>
        <NonProfitIndustryPage
          data={acf}
          isSchedulerOpen={this.state.isSchedulerOpen}
          toggleIsSchedulerOpen={this.toggleIsSchedulerOpen}
        />
        <FooterNewsModal />
        <FooterComponent phone_number={acf.phone_number_setup} />
      </div>
    );
  }
}

export const getStaticProps = async () => {
  const { data } = await axios.get(`${WordPressAPI.pages}/20805`);

  return {
    props: {
      data,
    },
    // revalidate: 1,
  };
};

export default NonProfitIndustry;
